import Highcharts from 'highcharts';
import ChartColors from '../../../../../js/utility/ChartColors';
import ChartConstants from './ChartConstants';

const HighchartsAccessibility = require('highcharts/modules/accessibility');
HighchartsAccessibility(Highcharts);
const HighchartsExporting = require('highcharts/modules/exporting');
HighchartsExporting(Highcharts);

Highcharts.setOptions({
	colors: ChartColors.COLORS,
	chart: {
		backgroundColor: ChartConstants.PLOT_BACKGROUND,
		style: {
			fontFamily: ChartConstants.FONT_FAMILY,
		},
	},
});

export default Highcharts;
